export default __webpack_public_path__ + "f258743222a47bcf12f9a25f3752c40d.svg";